import React from "react";

function ToolsSection() {

    const cards = [
        {
            title: "Custom card design",
            text: "Create beautiful digital stamp cards personalized with your brand, logo, and colors.",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="#fff" width="60px" height="60px"><path d="M295.4 37L310.2 73.8L347 88.6C350 89.8 352 92.8 352 96C352 99.2 350 102.2 347 103.4L310.2 118.2L295.4 155C294.2 158 291.2 160 288 160C284.8 160 281.8 158 280.6 155L265.8 118.2L229 103.4C226 102.2 224 99.2 224 96C224 92.8 226 89.8 229 88.6L265.8 73.8L280.6 37C281.8 34 284.8 32 288 32C291.2 32 294.2 34 295.4 37zM142.7 105.7L164.2 155.8L214.3 177.3C220.2 179.8 224 185.6 224 192C224 198.4 220.2 204.2 214.3 206.7L164.2 228.2L142.7 278.3C140.2 284.2 134.4 288 128 288C121.6 288 115.8 284.2 113.3 278.3L91.8 228.2L41.7 206.7C35.8 204.2 32 198.4 32 192C32 185.6 35.8 179.8 41.7 177.3L91.8 155.8L113.3 105.7C115.8 99.8 121.6 96 128 96C134.4 96 140.2 99.8 142.7 105.7zM496 368C502.4 368 508.2 371.8 510.7 377.7L532.2 427.8L582.3 449.3C588.2 451.8 592 457.6 592 464C592 470.4 588.2 476.2 582.3 478.7L532.2 500.2L510.7 550.3C508.2 556.2 502.4 560 496 560C489.6 560 483.8 556.2 481.3 550.3L459.8 500.2L409.7 478.7C403.8 476.2 400 470.4 400 464C400 457.6 403.8 451.8 409.7 449.3L459.8 427.8L481.3 377.7C483.8 371.8 489.6 368 496 368zM492 64C503 64 513.6 68.4 521.5 76.2L563.8 118.5C571.6 126.4 576 137 576 148C576 159 571.6 169.6 563.8 177.5L475.6 265.7L374.3 164.4L462.5 76.2C470.4 68.4 481 64 492 64zM76.2 462.5L340.4 198.3L441.7 299.6L177.5 563.8C169.6 571.6 159 576 148 576C137 576 126.4 571.6 118.5 563.8L76.2 521.5C68.4 513.6 64 503 64 492C64 481 68.4 470.4 76.2 462.5z"/></svg>
            )
        },
        {
            title: "Message customers",
            text: "Send the right offers and updates to the right audience.",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" fill="#fff" width="60px" height="60px">
                    <path d="M320 64C306.7 64 296 74.7 296 88L296 97.7C214.6 109.3 152 179.4 152 264L152 278.5C152 316.2 142 353.2 123 385.8L101.1 423.2C97.8 429 96 435.5 96 442.2C96 463.1 112.9 480 133.8 480L506.2 480C527.1 480 544 463.1 544 442.2C544 435.5 542.2 428.9 538.9 423.2L517 385.7C498 353.1 488 316.1 488 278.4L488 263.9C488 179.3 425.4 109.2 344 97.6L344 87.9C344 74.6 333.3 63.9 320 63.9z" />
                </svg>
            )
        },
        {
            title: "Fast sign-ups",
            text: "Customers join within seconds using QR or link.",
            icon: (
               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="60px" height="60px" fill="#fff"><path d="M192 384L88.5 384C63.6 384 48.3 356.9 61.1 335.5L114 247.3C122.7 232.8 138.3 224 155.2 224L250.2 224C326.3 95.1 439.8 88.6 515.7 99.7C528.5 101.6 538.5 111.6 540.3 124.3C551.4 200.2 544.9 313.7 416 389.8L416 484.8C416 501.7 407.2 517.3 392.7 526L304.5 578.9C283.2 591.7 256 576.3 256 551.5L256 448C256 412.7 227.3 384 192 384L191.9 384zM464 224C464 197.5 442.5 176 416 176C389.5 176 368 197.5 368 224C368 250.5 389.5 272 416 272C442.5 272 464 250.5 464 224z"/></svg>
            )
        },
        {
            title: "Measure performance",
            text: "Track loyalty performance and ROI in real-time.",
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" width="60px" height="60px" fill="#fff"><path d="M160 96C124.7 96 96 124.7 96 160L96 480C96 515.3 124.7 544 160 544L480 544C515.3 544 544 515.3 544 480L544 160C544 124.7 515.3 96 480 96L160 96zM216 288C229.3 288 240 298.7 240 312L240 424C240 437.3 229.3 448 216 448C202.7 448 192 437.3 192 424L192 312C192 298.7 202.7 288 216 288zM400 376C400 362.7 410.7 352 424 352C437.3 352 448 362.7 448 376L448 424C448 437.3 437.3 448 424 448C410.7 448 400 437.3 400 424L400 376zM320 192C333.3 192 344 202.7 344 216L344 424C344 437.3 333.3 448 320 448C306.7 448 296 437.3 296 424L296 216C296 202.7 306.7 192 320 192z"/></svg>
            )
        },
    ];

    return (
        <section className="tools-section homebox2main">

            <div className="container">

                <div className="tools-main">

                    {/* LEFT SIDE */}
                    <div className="homebox2-right tools-left">
                        <span>One platform.</span>

                        <h2>Smarter loyalty management.</h2>

                        <p>
                            Loyalific brings together customer enrolment,
                            digital stamping, messaging, reporting, and card management
                            into one streamlined system.
                        </p>

                        <ul>
                            <li>Monitor loyalty activity at a glance</li>
                            <li>See what campaigns perform best</li>
                            <li>Keep your most loyal customers coming back</li>
                        </ul>
                    </div>

                    {/* RIGHT SIDE SLIDER */}
                    <div className="tools-right">

                        <div className="slider-wrapper">

                            <div className="tools-track">

                                {[...cards, ...cards].map((item, i) => (
                                    <div className="tool-card" key={i}>

                                        <div className="icon-box">
                                            {item.icon}
                                        </div>

                                        <h3>{item.title}</h3>

                                        <p>{item.text}</p>

                                    </div>
                                ))}

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </section>
    );
}

export default ToolsSection;